import { render, staticRenderFns } from "./PictureUpload.vue?vue&type=template&id=0d37a0d2"
import script from "./PictureUpload.vue?vue&type=script&lang=ts"
export * from "./PictureUpload.vue?vue&type=script&lang=ts"
import style0 from "./PictureUpload.vue?vue&type=style&index=0&id=0d37a0d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports